import { Link, useLocation } from "react-router-dom";
import Eyebrow from "@/components/base/Eyebrow";
import MicroLabel from "@/components/base/MicroLabel";
import Reveal from "@/components/base/Reveal";
import NotFoundTicket from "@/pages/not-found/components/NotFoundTicket";
import SiteIndex from "@/pages/not-found/components/SiteIndex";

export default function NotFound() {
  const { pathname, search, hash } = useLocation();
  const requested = `${pathname}${search}${hash}`;

  return (
    <>
      <section className="relative overflow-hidden bg-foreground-950 pt-28 md:pt-32 pb-16 md:pb-24">
        <div className="absolute inset-0 grid-pattern-light pointer-events-none" aria-hidden="true"></div>
        <div className="absolute right-0 top-0 h-full w-1.5 bg-primary-500 hidden md:block" aria-hidden="true"></div>

        <div className="relative px-4 md:px-8">
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
            <Reveal className="lg:col-span-7">
              <Eyebrow tone="onDark">Error 404</Eyebrow>

              <p
                className="mt-4 font-heading font-black leading-[0.72] tracking-tight text-stroke text-primary-500 text-[6rem] md:text-[10rem] lg:text-[11rem] select-none"
                aria-hidden="true"
              >
                404
              </p>

              <div className="mt-5">
                <MicroLabel mark="dot" tone="onDarkAccent">
                  Request received · nothing matched
                </MicroLabel>
              </div>

              <h1 className="mt-4 font-heading font-black uppercase leading-[0.9] tracking-tight text-background-50 text-3xl md:text-5xl max-w-2xl">
                This page never filled
              </h1>

              <p className="mt-5 text-sm md:text-base leading-relaxed text-background-300 max-w-xl">
                The address is well formed, but nothing rests there. No position was opened, nothing
                was charged, and nothing is waiting on you — the order simply came back unfilled.
              </p>

              <div className="mt-9 flex flex-wrap items-center gap-3">
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 px-6 py-3.5 border-2 border-primary-500 bg-primary-500 font-label text-[11px] uppercase tracking-[0.16em] font-semibold text-foreground-950 hover:bg-background-50 hover:border-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-home-4-line"></i>
                  Back to home
                </Link>
                <Link
                  to="/glossary"
                  className="inline-flex items-center gap-2 px-6 py-3.5 border-2 border-background-50 font-label text-[11px] uppercase tracking-[0.16em] font-semibold text-background-50 hover:bg-background-50 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-book-open-line"></i>
                  Browse the glossary
                </Link>
              </div>
            </Reveal>

            <Reveal delay={120} className="lg:col-span-5">
              <NotFoundTicket requested={requested} />
              <p className="mt-4 text-xs leading-relaxed text-background-400">
                The full address you asked for is on the ticket. If it came from a link on another
                site, that link is the thing that needs fixing — not your typing.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <SiteIndex />
    </>
  );
}